import React from "react";
import Section from "./Section";
import FeaturesColumn from "./FeaturesColumn";
import "./FeaturesSection4.scss";

function FeaturesSection4(props) {
  return (
    <Section
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="container">
        <div className="columns is-vcentered is-variable is-4 is-desktop">
          <div className="column is-12 is-2-desktop">
            <FeaturesColumn
              textAlign="right"
              items={[
                {
                  title: "Register and Protect",
                  description: "Register and copyright your assets on the blockchain to assert ownership and licensing rights",
                  iconClass: "fas fa-shield",
                  iconColor: "info",
                },
                {
                  title: "Detect GPT Usage and Infringement",
                  description: "Use embedded infringement detection tools to compare the GPT-generated output data against registered data/IP assets and trigger automatic license deals.",
                  iconClass: "fas fa-binoculars",
                  iconColor: "info",
                },
                {
                  title: "Buy and Sell LLM Access/Usage Rights",
                  description: "License and track LLM usage of your data/IP registered on Żetonium to detect misuse.",
                  iconClass: "fas fa-handshake",
                  iconColor: "info",
                },
              ]}
            />
          </div>
          <div className="column">
            <figure className="FeaturesSection4__image image">
              <img src={props.image} alt="Illustration" />
            </figure>
          </div>
          <div className="column is-12 is-2-desktop">
            <FeaturesColumn
              textAlign="left"
              items={[
                {
                  title: "Receive Royalties",
                  description: "Receive royalty payments automatically and in real time when an LLM uses your data/IP for training or if a GPT prompt output is similar enough to registered work to trigger a use license deal.",
                  iconClass: "fas fa-money-bill-wave",
                  iconColor: "primary",
                },
                {
                  title: "Audit Usage and Payments",
                  description: "All payments for licenses and asset usage are settled automatically on DASE, and are fully auditable in real time via API.",
                  iconClass: "fas fa-clipboard",
                  iconColor: "primary",
                },
                {
                  title: "End-to-End Rights Management",
                  description: "Work with us to foster an accountable and sustainable AI ecosystem that respects intellectual property rights while empowering human creativity.",
                  iconClass: "fas fa-gear",
                  iconColor: "primary",
                },
              ]}
            />
          </div>
        </div>
      </div>
    </Section>
  );
}

export default FeaturesSection4;
